import RoutePage from "./Routes/Routes";
import "./App.css";
function App() {
  return (
    <>
      <div className="main work-sans">
        {" "}
        <RoutePage />
      </div>
    </>
  );
}

export default App;
